import { useEffect } from "react";
import { PageHeader, FadeUp } from "./Reveal";

export const usePageMeta = (title, description) => {
    useEffect(() => {
        document.title = title;
        let meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", description);
        return () => {
            document.title =
                "Eway Fiber Net | High-Speed FTTH Internet in Narasaraopet";
        };
    }, [title, description]);
};

export const Placeholder = ({ children }) => (
    <span className="rounded-md border border-amber-400/40 bg-amber-400/10 px-1.5 py-0.5 text-[0.92em] font-semibold text-amber-300">
        {children}
    </span>
);

export const LegalPage = ({ eyebrow, title, subtitle, updated, sections, testId }) => (
    <>
        <PageHeader
            testId={testId}
            eyebrow={eyebrow}
            title={title}
            subtitle={subtitle}
        />
        <section className="mx-auto max-w-4xl px-4 pb-24 sm:px-6 lg:px-8">
            <p className="mb-10 font-mono text-xs tracking-widest text-slate-500">
                LAST UPDATED: {updated}
            </p>
            <div className="space-y-10">
                {sections.map((s, i) => (
                    <FadeUp key={s.heading} delay={Math.min(i * 0.03, 0.2)}>
                        <article
                            data-testid={`legal-section-${i + 1}`}
                            className="glass rounded-3xl p-6 sm:p-8"
                        >
                            <h2 className="font-display text-lg font-bold text-white sm:text-xl">
                                {i + 1}. {s.heading}
                            </h2>
                            <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-300 sm:text-base">
                                {s.body.map((para, j) => (
                                    <p key={j}>{para}</p>
                                ))}
                            </div>
                        </article>
                    </FadeUp>
                ))}
            </div>
        </section>
    </>
);
